module.exports = __webpack_public_path__ + "img/ishi.681144af.jpg";